import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor, FilterDescriptor, State } from '@progress/kendo-data-query';
import { GridView } from '../models/grid-view';
import { AuditLogModel } from './models/audit-log-model';

@Injectable({
  providedIn: 'root',
})
export class AuditLogAPIService extends BehaviorSubject<GridDataResult> {
    public baseUrlLocal: string = environment.apiBaseUrl;
    public loading: boolean = false;

    constructor(private http: HttpClient) {
        super({ data: [], total: null });
    }

    public query(state: State, filter: CompositeFilterDescriptor): void {
        this.loading = true;
        this.fetch(state, filter).subscribe((x) => super.next(x));
    }

    protected fetch(state: State, filter: CompositeFilterDescriptor): Observable<GridDataResult> {
        let queryStart = '';
        let queryString = '';

        queryStart = this.getQueryStart(queryStart);
        queryString = queryString.concat(`${queryStart}pageindex=${state.skip}`);
        queryStart = this.getQueryStart(queryStart);
        queryString = queryString.concat(`${queryStart}pagesize=${state.take}`);

        const entityFilter = this.getStateFilterValue(filter, 'entity');
        if (entityFilter != undefined && entityFilter.length >= 3) {
            queryString = queryString.concat(`${queryStart}entity=${encodeURIComponent(entityFilter)}`);
        }

        const columnFilter = this.getStateFilterValue(filter, 'column');
        if (columnFilter != undefined && columnFilter.length >= 3) {
            queryString = queryString.concat(`${queryStart}column=${encodeURIComponent(columnFilter)}`);
        }

        const updatedByFilter = this.getStateFilterValue(filter, 'updatedBy');
        if (updatedByFilter != undefined && updatedByFilter.length >= 3) {
            queryString = queryString.concat(`${queryStart}updatedBy=${encodeURIComponent(updatedByFilter)}`);
        }

        const itemIdFilter = this.getStateFilterValue(filter, 'itemId');
        if (itemIdFilter != undefined && itemIdFilter.length >= 3) {
            queryString = queryString.concat(`${queryStart}itemId=${encodeURIComponent(itemIdFilter)}`);
        }

        const supplierIdFilter = this.getStateFilterValue(filter, 'supplierId');
        if (supplierIdFilter != undefined && supplierIdFilter.length >= 3) {
            queryString = queryString.concat(`${queryStart}supplierId=${encodeURIComponent(supplierIdFilter)}`);
        }

         return this.http.get<GridDataResult>(this.baseUrlLocal + `userauditlog/search` + queryString)
          .pipe(
              map(
              (response: GridDataResult) => {
                  return {
                      data: response.data,
                      total: response.total
                  };
              }
              ), tap(() => (this.loading = false))
          );
    }

    private getQueryStart(queryStart: string): string {
        return queryStart === '' ? '?' : '&';
    }

    private getStateFilterValue(filter: CompositeFilterDescriptor, field: string): string | undefined {
        if (!filter?.filters?.length) {
            return undefined;
        }
        const matchingFilter = filter.filters.find((item): item is FilterDescriptor => {
            return !('filters' in item) && item.field === field;
        });
        if (matchingFilter?.value === undefined || matchingFilter.value === null) {
            return undefined;
        }
        return String(matchingFilter.value);
    }
}

@Injectable()
export class AuditLogService extends AuditLogAPIService {
  constructor(http: HttpClient) {
      super(http);
  }
}


